<template lang="pug">
    div.arrow-next(@click="click")
      i.el-icon-arrow-right.arrow-next-icon
</template>

<script>

export default {
  name: 'ArrowNext',  
  methods: {    
	click(event){
		this.$emit("arrow-next");
	}
  }
}
</script>

<style scoped>
@import 'arrow-next.scss';
</style>

